<template>
  <div class="list white" v-if="!isAgent" @click="toDetail">
    <!--    {{sname[showType].coverImage}}-->
    <div class="left imgbox">
      <img v-if="item[sname[showType].coverImage]" :src="item[sname[showType].coverImage]+sname[showType].after" alt="">
    </div>
    <div class="right">
      <div class="content">
        <p class="pub_left f14 two_line">
          <img v-if="item.user_type==='0'" src="../assets/image/common/taobao.png" alt="" class="biaoshi">
          <img v-if="item.user_type==='1'" src="../assets/image/common/tianmao.png" alt="" class="biaoshi">
          <img v-if="showType==='pdd'" src="../assets/image/common/pinduoduo.png" alt="" class="biaoshi">
          <img v-if="showType==='1'" src="../assets/image/common/yundian.png" alt="" class="biaoshi">
          <img v-if="showType==='jd'" src="../assets/image/common/jingdong.png" alt="" class="biaoshi">
          <b class="">{{ item[sname[showType].productName] }}</b>
        </p>
        <div class="right_bot">
          <p class="flex">
            <span v-if="showType==='jd'"
                  class="price f14 main_co">￥{{ item.price }}</span>
            <span v-else-if="showType==='pdd'"
                  class="price f14 main_co">￥{{ item[sname[showType].price] ? (item[sname[showType].price] * sname[showType].pricepoint - item[sname[showType].couponMoney] * sname[showType].pricepoint).toFixed(2) : '' }}</span>
            <span v-else
                  class="price f14 main_co">￥{{ item[sname[showType].price] ? (item[sname[showType].price] * sname[showType].pricepoint).toFixed(2) : item.priceInfo.lowestPrice }}</span>
            <span
              class="oldprice f12 gray_f">￥{{ item[sname[showType].originalPrice] }}</span>
          </p>
          <p class="num f12 gray_f pub_left">已售 {{ item[sname[showType].salesVolume] }}</p>
<!--          <div class="flex space_between main_co" style="padding-bottom:.1rem;" v-if="item[sname[showType].isbd]=='4'">-->
<!--            <p class="beneif">差额￥{{ Number(item[sname[showType].diff]).toFixed(2) }}</p>-->
<!--            &lt;!&ndash;<p class="beneif">推广差额￥{{Number(item[sname[showType].extensiondiff]).toFixed(2)}}</p>&ndash;&gt;-->
<!--          </div>-->
          <div class="flex space_between">
            <div class="flex">
              <span v-if="showType==='jd'"
                    class="ticket f12 white_f main_bg">{{ item.coupon }}元券</span>
              <span v-else
                    class="ticket f12 white_f main_bg">{{ (item[sname[showType].couponMoney] * sname[showType].pricepoint).toFixed(0) }}元券</span>
            </div>
            <div class="flex flex_end">
              <span v-if="showType==='pdd'&& is_bj=='true'" class="f12 trans beneif"
                    style="margin-right: .12rem;">0铜板</span>
              <span v-if="showType==='pdd'&& is_bj=='true'" class="ticket f12 white_f"
                    style="background-color: #aaaaaa;">比价</span>
              <span v-else-if="showType==='pdd' && is_bj=='false'"
                    class="f12 trans beneif">{{ (parseInt(item[sname[showType].rate] * 1 * ((item[sname[showType].price] * 1 - item[sname[showType].couponMoney] * 1) * sname[showType].zkrate * sname[showType].pricepoint) / (sname[showType].point) * 100) * 0.01).toFixed(2) }}铜板</span>
              <span v-else-if="showType==='jd'"
                    class="f12 trans beneif">{{ item.tongBan }}铜板</span>
              <span v-else
                    class="f12 trans beneif">{{ item[sname[showType].integral] ? (parseInt(item[sname[showType].integral] * 1 * sname[showType].zkrate * 100) * 0.01).toFixed(2) : (parseInt(item[sname[showType].rate] * 1 * (item[sname[showType].price] * sname[showType].zkrate * sname[showType].pricepoint) / (sname[showType].point * 1) * 100) * 0.01).toFixed(2) }}铜板</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="list white" v-else-if="isAgent && item[sname[showType].isdl]!=='0' && item[sname[showType].ishot]!=='1'"
       @click="toDetail">
    <!--    {{sname[showType].coverImage}}-->
    <div class="left imgbox">
      <img v-if="item[sname[showType].coverImage]" :src="item[sname[showType].coverImage]+sname[showType].after" alt="">
    </div>
    <div class="right">
      <div class="content">
        <p class="pub_left f14 two_line">
          <img v-if="item.user_type==='0'" src="../assets/image/common/taobao.png" alt=""
               style="height: .37rem;margin-right: .1rem">
          <img v-if="item.user_type==='1'" src="../assets/image/common/tianmao.png" alt=""
               style="height: .37rem;margin-right: .1rem">
          <img v-if="showType==='pdd'" src="../assets/image/common/pinduoduo.png" alt=""
               style="height: .37rem;margin-right: .1rem">
          <img v-if="showType==='jd'" src="../assets/image/common/jingdong.png" alt=""
               style="height: .37rem;margin-right: .1rem">
          <b class="">{{ item[sname[showType].productName] }}</b>
        </p>
        <div class="flex space_between">
          <p class="flex flex_start">
            <span v-if="showType==='jd'"
                  class="price f16 main_co">￥{{ item.price }}</span>
            <span v-else-if="showType==='pdd'"
                  class="price f16 main_co">￥{{ item[sname[showType].price] ? (item[sname[showType].price] * sname[showType].pricepoint - item[sname[showType].couponMoney] * sname[showType].pricepoint).toFixed(2) : '' }}</span>
            <span v-else
                  class="price f16 main_co">￥{{ item[sname[showType].price] ? (item[sname[showType].price] * sname[showType].pricepoint).toFixed(2) : item.priceInfo.lowestPrice }}</span>
            <span
              class="oldprice f12 gray_f">￥{{ item[sname[showType].originalPrice] }}</span>
          </p>
          <span class="num f12 gray_f pub_left">已售 {{ item[sname[showType].salesVolume] }}</span>
        </div>
        <div class="flex space_between bottom">
          <div class="bene">
            <span v-if="showType==='jd'"
                  class="ticket f12 white_f main_bg">{{ item.coupon }}元券</span>
            <span v-else
                  class="ticket f12 white_f main_bg">{{ (item[sname[showType].couponMoney] * sname[showType].pricepoint).toFixed(0) }}元券</span>
            <span v-if="showType==='pdd'"
                  class="f12 trans beneif">{{ (parseInt(item[sname[showType].rate] * 1 * ((item[sname[showType].price] * 1 - item[sname[showType].couponMoney] * 1) * sname[showType].zkrate * sname[showType].pricepoint) / (sname[showType].point) * 100) * 0.01).toFixed(2) }}铜板</span>
            <span v-else-if="showType==='jd'"
                  class="f12 trans beneif">{{ item.tongBan}}铜板</span>
            <span v-else
                  class="f12 trans beneif">{{ item[sname[showType].integral] ? (parseInt(item[sname[showType].integral] * 1 * sname[showType].zkrate * 100) * 0.01).toFixed(2) : (parseInt(item[sname[showType].rate] * 1 * (item[sname[showType].price] * sname[showType].zkrate * sname[showType].pricepoint) / (sname[showType].point * 1) * 100) * 0.01).toFixed(2) }}铜板</span>
          </div>
          <div class="main_bg white_f f14 agent" @click.stop="confirm">我要选货</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getpdditemtgurl} from '../api/home'

export default {
  props: {
    item: Object,
    type: String,
    isAgent: Boolean,
    // is_bj: Boolean,
    showType: {
      type: String,
      default() {
        return '1'
      }
    },
    is_bj: {
      type: String,
      default() {
        return 'false'
      }
    }
  },
  data() {
    return {
      userinfo: {}
    }
  },
  created() {
    // console.log(this.showType)
    // console.log('bj='+this.is_bj)
    this.userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
  },
  methods: {
    toDetail() {
      // if (this.isAgent) {
      //   return
      // }
      // if (this.showType === 'pdd') {
      // getpdditemtgurl({productId: this.item.goods_id, uid: localStorage.getItem('uid')}).then(res => {
      //   if (res.result === '0') {
      //     this.$dialog.confirm({
      //       title: '提示',
      //       message: '是否离开跳转拼多多？',
      //       confirmButtonColor: this.m_color
      //     }).then(() => {
      //       window.location.href = res.dataList[0].mobile_url
      //     })
      //   }
      // })
      // } else {
      // console.log(this.showType)
      // console.log(!this.showtype)
      // console.log(this.showType === '1')
      this.$router.push({path: '/goodDetail',
        query: {
          type: this.showType === '1' ? '1' : '',
          productId: this.item[this.sname[this.showType].productId],
          productSign: this.item[this.sname[this.showType].productSign],
          showType: this.showType,
          suid: localStorage.getItem('uid') ? localStorage.getItem('uid') : ''
        }
      })
      // }
    },
    confirm() {
      this.$emit('confirm', this.item)
    }
  }
}
</script>

<style scoped>
.list {
  padding: 0 5%;
  display: flex;
  justify-content: stretch;
  align-items: flex-start;
}

.left {
  /*flex: 0;*/
  width: 3.2rem;
  height: 3.2rem;
}

.left img {

}

.right {
  margin-left: 5%;
  flex: 1;
  position: relative;
  height: 3.2rem;
  line-height: .6rem;
}

.right_bot {
  /*position: absolute;*/
  /*left: 0;*/
  /*bottom: .2rem;*/
  /*width: 100%;*/
}

.right .bottom {
  position: absolute;
  left: 0;
  bottom: .2rem;
  width: 100%;
}

.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.price {
}

.oldprice {
  text-decoration: line-through;
  margin-left: .2rem;
}

.ticket {
  /*background: red;*/
  padding: 4px .12rem; /*no*/
  margin-right: .2rem;
  border-radius: .1rem;
  line-height: 1;
}

.ticket2 {
  /*background: red;*/
  padding: 2px .06rem; /*no*/
  /*margin-right: .03rem;*/
  border-radius: .06rem;
  line-height: 1;
  border: 1px solid #F14547;
}

.bene {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2%;
}

.bene span {
  display: inline-block;
  /*line-height: 1.5;*/
  margin-bottom: .1rem;
  border-radius: .1rem;
  /*background: #ffe8e0;*/
}

.agent {
  padding: 0 .2rem;
  line-height: .8rem;
  border-radius: .1rem;
}

.biaoshi {
  height: 14px;
  line-height: .6rem;
  vertical-align: top;
  /*margin-right: .1rem;*/
  margin-top: .1rem;
}

.two_line {
  height: 3em;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/goodList.vue